import { PaletteFragmentFragment } from "src/api/graphql/__generated__/graphql";

const isPaletteMatch = (
	a: PaletteFragmentFragment | null | undefined,
	b: PaletteFragmentFragment | null | undefined,
) => {
	if (a == null || b == null) return false;
	if (a.primary == null || a.secondary == null || a.tertiary == null) return false;
	if (b.primary == null || b.secondary == null || b.tertiary == null) return false;
	return a.primary === b.primary && a.secondary === b.secondary && a.tertiary === b.tertiary;
};
export default isPaletteMatch;
